export default "<p>\r\n  news works!\r\n</p>\r\n";